/** Notification snapshots may only navigate within the current application. */
export const getNotificationUrl = (value: string | null | undefined, origin: string): string | null => {
  if (!value) return null
  try {
    const url = new URL(value, origin)
    if (
      (url.protocol !== 'https:' && url.protocol !== 'http:') ||
      url.origin !== origin ||
      url.username ||
      url.password
    ) {
      return null
    }
    return url.href
  } catch {
    return null
  }
}
